import { combineReducers } from 'redux';
import { machineFmeaConstants } from './machineFmea.constants';

const assignmentInitial = { loading: false, data: null, error: null };
const templatesInitial = { loading: false, data: [], error: null };

function assignment(state = assignmentInitial, action) {
  switch (action.type) {
    case machineFmeaConstants.GET_MACHINE_FMEA_REQUEST:
      return { ...state, loading: true, error: null };
    case machineFmeaConstants.GET_MACHINE_FMEA_SUCCESS:
      return { loading: false, data: action.data, error: null };
    case machineFmeaConstants.GET_MACHINE_FMEA_FAILURE:
      return { loading: false, data: null, error: action.error };
    default:
      return state;
  }
}

function templates(state = templatesInitial, action) {
  switch (action.type) {
    case machineFmeaConstants.GET_FMEA_TEMPLATES_REQUEST:
      return { ...state, loading: true, error: null };
    case machineFmeaConstants.GET_FMEA_TEMPLATES_SUCCESS:
      return { loading: false, data: action.data || [], error: null };
    case machineFmeaConstants.GET_FMEA_TEMPLATES_FAILURE:
      return { loading: false, data: [], error: action.error };
    default:
      return state;
  }
}

export const machineFmeaReducer = combineReducers({ assignment, templates });
